var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insure-form-payment"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/loading.gif")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }